export default "__VITE_ASSET__CsP7Q9j9__"